import classNames from 'classnames/bind';
import styles from './MyTask.module.scss';
import TableClassicReport from '../base/TableClassicReport';
import { useEffect, useState } from 'react';
import { IMyTaskRecord, IPaginationReport } from '~/utils/interface/report';
import reportApi from '~/apis/report';
import { ColumnType } from '~/utils/types/common';
import dayjs from 'dayjs';

const cx = classNames.bind(styles);

const MyTask = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IMyTaskRecord[]>([]);
  const [pagination, setPagination] = useState<IPaginationReport>({
    totalItems: 0,
    totalPage: 0,
    page: 1,
    limit: 10,
    skip: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await reportApi.getMyTasks({ page: pagination.page });
        setData(response.data?.data?.responses ?? []);
        setPagination(response.data?.data?.pagination ?? {
          totalItems: 0,
          totalPage: 0,
          page: 1,
          limit: 10,
          skip: 0,
        });
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch my tasks', error);
        setLoading(false);
      }
    };
    fetchData();
  }, [pagination.page]);


  const columns: Array<ColumnType> = [
    {
      id: "title",
      labelHeader: "Title",
      renderCell: (task: IMyTaskRecord) => (
        <div
          className={cx("cell")}
        >
          <p className={cx("text-content")}>{task.title || "-"}</p>
        </div>
      ),
    },
    {
      id: "type",
      labelHeader: "Type",
      renderCell: (task: IMyTaskRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{task.type || "-"}</p>
        </div>
      ),
    },
    {
      id: "startDate",
      labelHeader: "Start Date",
      renderCell: (task: IMyTaskRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{dayjs(task.startDate).format("MM/DD/YYYY hh:mm A") || "-"}</p>
        </div>
      ),
    },
    {
      id: "priority",
      labelHeader: "Priority",
      renderCell: (task: IMyTaskRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{task.priority || "-"}</p>
        </div>
      ),
    },
    {
      id: "assignedTo",
      labelHeader: "Assigned To",
      renderCell: (task: IMyTaskRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{task.assignee?.name || "-"}</p>
        </div>
      ),
    },
    {
      id: "relatedRecords",
      labelHeader: "Related Records",
      renderCell: (task: IMyTaskRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{task.job?.customerName || "-"}</p>
          <p className={cx("text-content")}>{task.job?.uniqueCode ? `${task.job?.uniqueCode} (Job)` : "-"}</p>
        </div>
      ),
    },
    {
      id: "description",
      labelHeader: "Description",
      renderCell: (task: IMyTaskRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{task.description || "-"}</p>
        </div>
      ),
    },
  ];

  return (
    <TableClassicReport
      title="My Tasks"
      columns={columns}
      data={data}
      page={pagination.page}
      totalPages={pagination.totalPage}
      totalItems={pagination.totalItems}
      itemsPerPage={pagination.limit}
      onPageChange={(page) => {
        setPagination({ ...pagination, page });
      }}
      isLoading={loading}
    />
  );
};

export default MyTask;
